function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.24179 13.0949C9.69226 13.1657 10 13.5706 10 14.0266V20C10 20.5523 9.55229 21 9 21H2.58457e-07C-0.000310114 19.7789 0.278921 18.5739 0.816299 17.4774C1.35368 16.3809 2.13494 15.4219 3.10022 14.674C4.0655 13.9261 5.18918 13.4091 6.38515 13.1626C7.32764 12.9684 8.29531 12.9462 9.24179 13.0949ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM14 16V14C14 13.4477 14.4477 13 15 13C15.5523 13 16 13.4477 16 14V16H18C18.5523 16 19 16.4477 19 17C19 17.5523 18.5523 18 18 18H16V20C16 20.5523 15.5523 21 15 21C14.4477 21 14 20.5523 14 20V18H12C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16H14Z",
  fill: "#008A94"
});

function SvgSignupMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupMenuIcon);
export default __webpack_public_path__ + "static/media/signup-menu-icon.4206652e.svg";
export { ForwardRef as ReactComponent };